// extracted by mini-css-extract-plugin
export default {"list-popover":"ListPopover_list-popover__vAeCc"};